import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-290e1a3d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "difficulty" }
const _hoisted_2 = { class: "difficulty__value" }
const _hoisted_3 = { class: "difficulty__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "difficulty__button difficulty__button--up",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setDifficulty(_ctx.modelValue + 1)))
    }, [
      _createVNode(_component_Icon, { name: "Caret" })
    ]),
    _createElementVNode("button", {
      class: "difficulty__button difficulty__button--down",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setDifficulty(_ctx.modelValue - 1)))
    }, [
      _createVNode(_component_Icon, { name: "Caret" })
    ]),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.modelValue), 1),
    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('difficulty')), 1)
  ]))
}